<template>
    <div class="tool-bar" @mouseleave="showSearch=false">
      <div  class="search-input-div" >
        <transition name="open"><input class="search-input" ref="searchInput"
             :class="globalTransition?'global-i18n-hide-p':'global-i18n-not-hide-p'"
             v-show="showSearch" :placeholder="$t('toolBar.searchPlaceholder')"/>
        </transition>
      </div>
      <span class="icon-width"  @mouseenter="hoverSearch()">
        <i style="height: 22px;" class="el-icon-search"></i></span>
      <transition name="fade" mode="out-in">
        <span class="icon-width"
              @click="handleLangChange()" v-if="cLanguage==='zh'" key="span1">En</span>
        <span class="icon-width" @click="handleLangChange()" v-else key="span2">中</span>
      </transition>
      <transition name="fade" mode="out-in">
        <i v-if="showRightMenu" class="el-icon-close icon-width"
                    @click="$emit('menuClick')" key="icon1"></i>
        <img v-else class="icon-width"
             :src="breadUrl" alt="DIMER"
           @click="$emit('menuClick')" key="icon2"/></transition>
    </div>

</template>

<script>
import bread from '@/assets/icon/bread.svg';

export default {
  name: 'toolBar',
  props: {
    showRightMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cLanguage: '',
      showSearch: false,
      breadUrl: bread,
    };
  },
  mounted() {
    this.cLanguage = this.language;
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition;
    },
  },
  methods: {
    handleLangChange() {
      const lang = this.language === 'zh' ? 'en' : 'zh';
      this.cLanguage = lang;
      this.$store.dispatch('app/setGlobalTransition', !this.globalTransition);
      setTimeout(() => {
        this.$i18n.locale = lang;
        this.$store.dispatch('app/setLanguage', lang);
        this.$store.dispatch('app/setGlobalTransition', !this.globalTransition);
      }, 250);
    },
    hoverSearch() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
  },
};
</script>

<style scoped>
.tool-bar{
  font-size: 24px;
  color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tool-bar > span,i{
  cursor: pointer;
}
.icon-width{
  cursor: pointer;
  width: 22px;
}
.open-enter-active, .open-leave-active {
  transition: .25s;
}
.open-enter, .open-leave-to {
  width: 0px;
  opacity: 0;
}
.open-enter-to, .open-leave {
  width: 184px;
  opacity: 100;
}
.search-input-div{
  width: 250px;
}
.search-input{
  background-color: transparent;
  color: #fff;
  float: right;
  height: 36px;
  border-radius: 24px;
  border-width: 2px;
  border-style: solid;
  padding: 4px 12px;
}
.search-input::placeholder{
  color: #fff;
}
.search-input:focus{
outline:none!important;
}
.global-i18n-hide-p::placeholder{
  opacity: 0;
  transition: ease 0.25s;
}
.global-i18n-not-hide-p::placeholder{
  opacity: 100;
  transition: ease 0.25s;
}
</style>



// WEBPACK FOOTER //
// src/components/headBar/toolBar/index.vue